import { render } from "./PanelGroup.vue?vue&type=template&id=39ca301d&scoped=true&ts=true"
import script from "./PanelGroup.vue?vue&type=script&lang=ts"
export * from "./PanelGroup.vue?vue&type=script&lang=ts"

import "./PanelGroup.vue?vue&type=style&index=0&id=39ca301d&lang=scss&scoped=true"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/lpoa_prod_deploy/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ca301d"]])

export default __exports__